<mat-spinner [strokeWidth]="strokeWidth()" [diameter]="diameter()"></mat-spinner>